/**
 * Quiz Diagnostic Peau — Ambréa
 * Fichier à placer dans : assets/quiz-diagnostic.js
 * Aucune dépendance externe. Compatible thème Online Store 2.0.
 */
(function () {
  'use strict';

  class AmbreaQuiz {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;

      const configEl = document.querySelector(
        `[data-quiz-config="${this.sectionId}"]`
      );
      if (!configEl) return;

      this.config = JSON.parse(configEl.textContent);
      this.currentIndex = 0;
      this.scores = {}; // { rougeurs: 0, teint: 0, imperfections: 0, fermete: 0 }
      this.selectedProfile = null;

      this.elements = {
        intro: root.querySelector('[data-screen="intro"]'),
        email: root.querySelector('[data-screen="email"]'),
        result: root.querySelector('[data-screen="result"]'),
        questionsContainer: root.querySelector('[data-questions-container]'),
        progressFill: root.querySelector('[data-progress-fill]'),
        progressLabel: root.querySelector('[data-progress-label]'),
        cartFeedback: root.querySelector('[data-cart-feedback]'),
        emailForm: root.querySelector('.quiz-email-form'),
        tagsField: root.querySelector('[data-tags-field]'),
      };

      this.renderQuestions();
      this.bindEvents();
      this.setScreen('intro'); // Garantit un état propre, y compris en cas de re-render Theme Editor
    }

    // ---------- RENDU DES QUESTIONS ----------
    renderQuestions() {
      const html = this.config.questions
        .map((question, qIndex) => {
          const options = question.options
            .map(
              (opt, oIndex) => `
              <button
                type="button"
                class="quiz-option"
                data-question-index="${qIndex}"
                data-option-index="${oIndex}"
              >
                <span class="quiz-option-marker"></span>
                <span class="quiz-option-label">${this.escapeHtml(opt.label)}</span>
              </button>
            `
            )
            .join('');

          return `
            <div class="quiz-question" data-question="${qIndex}" ${qIndex !== 0 ? 'hidden' : ''}>
              <h3 class="quiz-question-title">${this.escapeHtml(question.text)}</h3>
              <div class="quiz-options">${options}</div>
            </div>
          `;
        })
        .join('');

      this.elements.questionsContainer.innerHTML = html;
      this.updateProgress();
    }

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    // ---------- ÉVÉNEMENTS ----------
    bindEvents() {
      this.root.addEventListener('click', (e) => {
        const action = e.target.closest('[data-action]');
        if (action) {
          const type = action.dataset.action;
          if (type === 'start-quiz') this.startQuiz();
          if (type === 'prev-question') this.prevQuestion();
          if (type === 'skip-email') this.showResult();
          if (type === 'restart-quiz') this.restart();
          if (type === 'add-routine-to-cart') this.addRoutineToCart();
        }

        const option = e.target.closest('.quiz-option');
        if (option) this.selectOption(option);
      });

      if (this.elements.emailForm) {
        this.elements.emailForm.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleEmailSubmit();
        });
      }
    }

    // ---------- NAVIGATION ----------
    startQuiz() {
      this.setScreen('question');
      this.elements.intro.hidden = true;
    }

    selectOption(optionEl) {
      const qIndex = parseInt(optionEl.dataset.questionIndex, 10);
      const oIndex = parseInt(optionEl.dataset.optionIndex, 10);
      const option = this.config.questions[qIndex].options[oIndex];

      // Marquer visuellement la sélection
      const siblings = optionEl.parentElement.querySelectorAll('.quiz-option');
      siblings.forEach((el) => el.classList.remove('is-selected'));
      optionEl.classList.add('is-selected');

      // Comptabiliser le score du profil (si applicable)
      if (option.profile) {
        this.scores[option.profile] = (this.scores[option.profile] || 0) + 1;
      }

      // Avancer automatiquement après un court délai
      window.setTimeout(() => this.nextQuestion(), 280);
    }

    nextQuestion() {
      const isLast = this.currentIndex === this.config.questions.length - 1;
      if (isLast) {
        this.computeProfile();
        this.setScreen('email');
        return;
      }

      const current = this.elements.questionsContainer.querySelector(
        `[data-question="${this.currentIndex}"]`
      );
      current.hidden = true;

      this.currentIndex += 1;

      const next = this.elements.questionsContainer.querySelector(
        `[data-question="${this.currentIndex}"]`
      );
      next.hidden = false;

      this.updateProgress();
    }

    prevQuestion() {
      if (this.currentIndex === 0) {
        this.setScreen('intro');
        return;
      }

      const current = this.elements.questionsContainer.querySelector(
        `[data-question="${this.currentIndex}"]`
      );
      current.hidden = true;

      this.currentIndex -= 1;

      const prev = this.elements.questionsContainer.querySelector(
        `[data-question="${this.currentIndex}"]`
      );
      prev.hidden = false;

      this.updateProgress();
    }

    updateProgress() {
      const total = this.config.questions.length;
      const percent = Math.round(((this.currentIndex + 1) / total) * 100);
      if (this.elements.progressFill) {
        this.elements.progressFill.style.width = `${percent}%`;
      }
      if (this.elements.progressLabel) {
        this.elements.progressLabel.textContent = `${this.currentIndex + 1} / ${total}`;
      }
    }

    // ---------- CALCUL DU PROFIL ----------
    computeProfile() {
      let bestProfile = this.config.defaultProfile;
      let bestScore = -1;

      Object.entries(this.scores).forEach(([profile, score]) => {
        if (score > bestScore) {
          bestScore = score;
          bestProfile = profile;
        }
      });

      this.selectedProfile = bestProfile;
    }

    // ---------- EMAIL ----------
    handleEmailSubmit() {
      // On enrichit le tag Shopify avec le profil calculé pour la segmentation CRM
      if (this.elements.tagsField && this.selectedProfile) {
        this.elements.tagsField.value = `newsletter,quiz-lead,quiz-${this.selectedProfile}`;
      }

      // Soumission native Shopify (customer form) — pas de blocage JS,
      // on affiche directement le résultat en parallèle pour ne pas
      // faire attendre l'utilisatrice le rechargement de page.
      this.elements.emailForm.submit();
      this.showResult();
    }

    // ---------- RÉSULTAT ----------
    showResult() {
      this.setScreen('result');

      // Afficher uniquement le panneau du profil calculé
      const panels = this.root.querySelectorAll('[data-profile-panel]');
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.profilePanel !== this.selectedProfile;
      });
    }

    setScreen(screenName) {
      const screens = ['intro', 'question', 'email', 'result'];
      screens.forEach((name) => {
        if (name === 'question') {
          this.root
            .querySelectorAll('[data-screen-hide]')
            .forEach((el) => (el.hidden = screenName !== 'question'));
          this.elements.questionsContainer.hidden = screenName !== 'question';
          return;
        }
        const el = this.root.querySelector(`[data-screen="${name}"]`);
        if (el) el.hidden = name !== screenName;
      });
    }

    restart() {
      this.currentIndex = 0;
      this.scores = {};
      this.selectedProfile = null;

      this.root.querySelectorAll('.quiz-question').forEach((q, i) => {
        q.hidden = i !== 0;
      });
      this.root.querySelectorAll('.quiz-option').forEach((opt) => {
        opt.classList.remove('is-selected');
      });

      this.updateProgress();
      this.setScreen('intro');
    }

    // ---------- PANIER (AJAX) ----------
    addRoutineToCart() {
      const items = Array.from(
        this.root.querySelectorAll('[data-variant-id]')
      )
        .map((el) => el.dataset.variantId)
        .filter(Boolean)
        .map((id) => ({ id: parseInt(id, 10), quantity: 1 }));

      if (!items.length) return;

      this.elements.cartFeedback.textContent = 'Ajout en cours…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Erreur ajout panier');
          return res.json();
        })
        .then(() => {
          this.elements.cartFeedback.textContent = 'Routine ajoutée au panier ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // Si votre thème utilise un cart drawer, déclenchez-le ici, ex :
          // document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(() => {
          this.elements.cartFeedback.textContent =
            "Une erreur est survenue, merci de réessayer.";
        });
    }
  }

  function initQuizzes() {
    document.querySelectorAll('.quiz-section').forEach((root) => {
      if (!root.dataset.quizInitialized) {
        new AmbreaQuiz(root);
        root.dataset.quizInitialized = 'true';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initQuizzes);
  // Compatibilité éditeur de thème (Theme Editor live preview)
  document.addEventListener('shopify:section:load', initQuizzes);
})();